(function AdzukiCarousel($, Adzuki)
{
	'use strict';

	const component = {
		props: {
			images: {
				type    : Array,
				required: true,
			},
			showCaseOptions: {
				type   : Object,
				default: () => ({
					show : true,
					mode : 'grid',
					count: 3
				})
			},
			carouselOptions: {
				type   : Object,
				default: () => ({
					show    : true,
					mode    : 'overlay',
					rowCount: 10
				})
			}
		},
		template: `
			<div class="adzuki-carousel-image-grid">
				<template v-if="showcaseShow">
					<div v-if="showcaseMode === 'single'" class="adzuki-showcase showcase--single">
						<div
							class="showcase-item item-0 ajax-image-gallery"
							:style="{ backgroundImage: 'url(' + images[0]?.url ?? images[0]?.thumbnail_url + ')' }"
							:data-index="0"
							@click="openCarousel(0)"
						></div>
					</div>
					<div v-else :class="['adzuki-showcase', showcaseGridClass]">
						<template v-if="showcaseIsOdd">
							<div
								v-for="(image, index) in showcaseImages"
								:class="['showcase-item', 'ajax-image-gallery', showcaseItemClass(index)]"
								:style="{ backgroundImage: 'url(' + image?.thumbnail_url ?? image?.url + ')' }"
								:data-index="index"
								@click="openCarousel(index)"
							></div>
						</template>
						<template v-else>
							<div
								v-for="(image, index) in showcaseImages"
								:class="['showcase-item', 'ajax-image-gallery', 'item-' + index]"
								:style="{ backgroundImage: 'url(' + image?.url ?? image?.thumbnail_url + ')' }"
								:data-index="index"
								@click="openCarousel(index)"
							></div>
						</template>
					</div>
				</template>
				<div class="image-row" :class="showcaseShow ? 'margin10-top mt-1' : ''" v-if="rowShow">
					<div v-if="rowMode === 'scroll'" class="d-flex image-row--scroll">
						<div
							v-for="(image, index) in rowImages"
							class="img-item shelf-item flex-fill"
							:style="{ backgroundImage: 'url(' + image?.url ?? image?.thumbnail_url + ')' }"
							:data-index="showcaseCount + index"
							@click="openCarousel(showcaseCount + index)"
						></div>
					</div>
					<div v-else-if="rowMode === 'overlay'" class="image-row--overlay d-flex flex-row">
						<div
							v-for="(image, index) in overlayRowImages"
							class="img-item shelf-item flex-fill"
							:style="{ backgroundImage: 'url(' + image?.url ?? image?.thumbnail_url + ')' }"
							:data-index="showcaseCount + index"
							@click="openCarousel(showcaseCount + index)"
						>
							<div
								v-if="index === overlayRowImages.length - 1 && overlayRemainingCount > 0"
								class="item-overlay d-flex w-100 h-100"
							>
								<div class="align-self-center mx-auto">
									{{ overlayRemainingCount }} photos
								</div>
							</div>
						</div>
					</div>
					<div
						v-else-if="rowMode === 'single'"
						class="image-row--single"
						:style="{ backgroundImage: 'url(' + rowImages[0]?.url ?? rowImages[0]?.thumbnail_url + ')' }"
						@click="openCarousel(showcaseCount)"
					>
						<div class="image-row--single-count">
							<i class="fa fa-camera"></i> {{ images.length }}
						</div>
					</div>
				</div>
			</div>
			<div v-show="isCarouselOpen" class="carousel-overlay">
				<div class="carousel-content">
					<button @click="closeCarousel" class="close-btn">&times;</button>
					<div class="carousel-image">
						<img
							:src="images[currentImageIndex]?.url ?? images[currentImageIndex]?.thumbnail_url"
							:alt="'Image ' + currentImageIndex"
						/>
					</div>
					<button class="nav-btn prev" @click="prevImage">&#10094;</button>
					<button class="nav-btn next" @click="nextImage">&#10095;</button>
				</div>
			</div>
		`,
		data() {
			return {
				baseUri          : Adzuki.base_uri,
				isCarouselOpen   : false,
				currentImageIndex: 0,
				viewportWidth    : (typeof window === 'undefined' ? 1920 : window.innerWidth),
			};
		},
		computed: {
			showcaseShow() {
				return this.showCaseOptions?.show !== false;
			},
			showcaseMode() {
				return this.showCaseOptions?.mode || 'grid';
			},
			isXsViewport() {
				return this.viewportWidth < 768;
			},
			responsiveShowcaseCap() {
				if (this.viewportWidth < 768) {
					return 1; // xs
				}
				if (this.viewportWidth < 992) {
					return 2; // sm
				}
				if (this.viewportWidth < 1200) {
					return 3; // md
				}
				return 5; // lg+
			},
			showcaseCount() {
				if (this.showcaseMode === 'single') {
					return 1;
				}
				if (!this.showcaseShow) {
					return 0;
				}
				const configuredCount = this.showCaseOptions?.count || 3;
				const maxAllowedCount = Math.min(configuredCount, 5, this.images.length);

				return Math.min(maxAllowedCount, this.responsiveShowcaseCap);
			},
			showcaseImages() {
				return this.images.slice(0, this.showcaseCount);
			},
			showcaseIsOdd() {
				return this.showcaseCount % 2 !== 0;
			},
			showcaseGridClass() {
				return this.showcaseIsOdd
					? 'showcase--odd showcase--count-' + this.showcaseCount
					: 'showcase--even showcase--count-' + this.showcaseCount;
			},
			rowShow() {
				return this.carouselOptions?.show !== false;
			},
			rowMode() {
				return this.carouselOptions?.mode || 'overlay';
			},
			rowCount() {
				return this.carouselOptions?.rowCount || 10;
			},
			rowImages() {
				return this.images.slice(this.showcaseCount);
			},
			overlayViewportCount() {
				if (this.viewportWidth < 768) {
					return 2;
				}
				if (this.viewportWidth < 992) {
					return 3;
				}
				if (this.viewportWidth < 1200) {
					return 4;
				}
				return 6;
			},
			overlayVisibleCount() {
				const configuredMax = this.rowCount; // keep config as upper cap
				const responsiveMax = this.overlayViewportCount;
				return Math.min(configuredMax, responsiveMax, this.rowImages.length);
			},
			overlayRowImages() {
				return this.rowImages.slice(0, this.overlayVisibleCount);
			},
			overlayRemainingCount() {
				return Math.max(this.rowImages.length - this.overlayVisibleCount, 0);
			},
		},
		methods: {
			showcaseItemClass(index) {
				const isLarge = index === this.showcaseCount - 1;
				return isLarge ? 'item-large' : 'item-small item-small-' + index;
			},
			nextImage() {
				this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
			},
			prevImage() {
				this.currentImageIndex = (this.currentImageIndex - 1 + this.images.length) % this.images.length;
			},
			openCarousel(index) {
				this.isCarouselOpen = true;
				this.currentImageIndex = index;
			},
			closeCarousel() {
				this.isCarouselOpen = false;
			},
			handleResize() {
				this.viewportWidth = window.innerWidth;
			}
		},
		watch: {},
		mounted() {
			window.addEventListener('resize', this.handleResize, { passive: true });
		},
		beforeUnmount() {
			window.removeEventListener('resize', this.handleResize);
		},
	};

	Adzuki.VueComponents.AdzukiCarousel = component;
}(jQuery, window.Adzuki || {}));